import { render, staticRenderFns } from "./PatientModalMovePatientConfirm.vue?vue&type=template&id=48c7e3e4"
import script from "./PatientModalMovePatientConfirm.vue?vue&type=script&lang=js"
export * from "./PatientModalMovePatientConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports